var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("van-nav-bar", {
        attrs: {
          "safe-area-inset-top": "",
          "left-arrow": "",
          title: "成色效果",
          "right-text": "完成",
          fixed: "",
        },
        on: { "click-left": _vm.resultClick, "click-right": _vm.onClickRight },
      }),
      _c(
        "div",
        { staticClass: "box-back" },
        [
          _c("van-cell", {
            attrs: { "is-link": "", value: _vm.recipeAddData.recipeYear },
            on: { click: _vm.yearClick },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("span", { staticClass: "custom-title" }, [
                      _vm._v("年款"),
                    ]),
                    _c("span", { staticClass: "required-style" }, [
                      _vm._v("(必填)"),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("van-cell", {
            attrs: { "is-link": "", value: _vm.recipeAddData.carAgeDesc },
            on: { click: _vm.vehicleClick },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("span", { staticClass: "custom-title" }, [
                      _vm._v("车龄(年)"),
                    ]),
                    _c("span", { staticClass: "required-style" }, [
                      _vm._v("(必填)"),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          !_vm.recipeAddData.isAdmin
            ? _c("van-cell", {
                attrs: {
                  "is-link": "",
                  value: _vm.recipeAddData.uploadRegionName,
                },
                on: { click: _vm.territoryClick },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "custom-title" }, [
                            _vm._v("上传/地域选择"),
                          ]),
                          _c("span", { staticClass: "required-style" }, [
                            _vm._v("(必填)"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1499380209
                ),
              })
            : _vm._e(),
          _c("van-cell", {
            attrs: { "is-link": "", value: _vm.colorGroupName },
            on: { click: _vm.colorArrClick },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [
                    _c("span", { staticClass: "custom-title" }, [
                      _vm._v("颜色组别"),
                    ]),
                    _c("span", { staticClass: "required-style" }, [
                      _vm._v("(必填)"),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "van-row",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c("van-col", { attrs: { span: "1" } }),
              _c("van-col", { attrs: { span: "16" } }, [
                _c("span", { staticClass: "col-span" }, [
                  _vm._v("色差描述/使用建议"),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "van-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("van-col", { attrs: { span: "1" } }),
              _c(
                "div",
                { staticClass: "iptDeep" },
                [
                  _c(
                    "van-col",
                    { attrs: { span: "22" } },
                    [
                      _c("van-field", {
                        attrs: {
                          maxlength: "50",
                          rows: "2",
                          autosize: "",
                          type: "textarea",
                          placeholder: "评价一下产品色差......",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.recipeAddData.commentInfo,
                          callback: function ($$v) {
                            _vm.$set(_vm.recipeAddData, "commentInfo", $$v)
                          },
                          expression: "recipeAddData.commentInfo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("van-col", { attrs: { span: "1" } }),
            ],
            1
          ),
          _c(
            "van-row",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c("van-col", { attrs: { span: "1" } }),
              _c("van-col", { attrs: { span: "22" } }, [
                _c("span", { staticClass: "col-span" }, [
                  _vm._v("上传车身颜色效果图片"),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "van-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("van-col", { attrs: { span: "1" } }),
              _c(
                "van-col",
                { attrs: { span: "22" } },
                [
                  _c("van-uploader", {
                    attrs: {
                      "after-read": _vm.afterRead,
                      "before-delete": _vm.deleteRead,
                      "max-count": 2,
                    },
                    on: { oversize: _vm.onOversize },
                    model: {
                      value: _vm.fileList,
                      callback: function ($$v) {
                        _vm.fileList = $$v
                      },
                      expression: "fileList",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("van-cell", {
            attrs: {
              title: "车牌号",
              "is-link": "",
              value: _vm.recipeAddData.licenseNum,
            },
            on: { click: _vm.plateNumberClick },
          }),
          _c(
            "van-row",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c("van-col", { attrs: { span: "1" } }),
              _c("van-col", { attrs: { span: "16" } }, [
                _c("span", { staticClass: "col-span" }, [
                  _vm._v("备注（仅本店可见）"),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "van-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("van-col", { attrs: { span: "1" } }),
              _c(
                "div",
                { staticClass: "iptDeep" },
                [
                  _c(
                    "van-col",
                    { attrs: { span: "22" } },
                    [
                      _c("van-field", {
                        attrs: {
                          maxlength: "50",
                          rows: "2",
                          autosize: "",
                          type: "textarea",
                          placeholder: "说些什么",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.recipeAddData.recipeRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.recipeAddData, "recipeRemark", $$v)
                          },
                          expression: "recipeAddData.recipeRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("van-col", { attrs: { span: "1" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "van-button",
            { attrs: { round: "", type: "info" }, on: { click: _vm.endClick } },
            [_vm._v("完成")]
          ),
          _c("van-overlay", { attrs: { show: _vm.overlayShow } }, [
            _c(
              "div",
              { staticClass: "over-style" },
              [_c("van-loading", { attrs: { color: "#1989fa" } })],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          style: { height: "38%" },
          attrs: { position: "bottom", round: "" },
          model: {
            value: _vm.pickerShow,
            callback: function ($$v) {
              _vm.pickerShow = $$v
            },
            expression: "pickerShow",
          },
        },
        [
          _c("van-picker", {
            attrs: {
              title: "选择年款",
              "show-toolbar": "",
              "default-index": "1",
              columns: _vm.columns,
            },
            on: { confirm: _vm.onConfirm, cancel: _vm.onCancel },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          style: { height: "38%" },
          attrs: { position: "bottom", round: "" },
          model: {
            value: _vm.pickerVehicleShow,
            callback: function ($$v) {
              _vm.pickerVehicleShow = $$v
            },
            expression: "pickerVehicleShow",
          },
        },
        [
          _c("van-picker", {
            attrs: {
              title: "选择车龄",
              "show-toolbar": "",
              "default-index": "1",
              columns: _vm.vehicleColumns,
            },
            on: { confirm: _vm.vehicleOnConfirm, cancel: _vm.vehicleOnCancel },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          style: { height: "38%" },
          attrs: { position: "bottom", round: "" },
          model: {
            value: _vm.pickerTerritoryShow,
            callback: function ($$v) {
              _vm.pickerTerritoryShow = $$v
            },
            expression: "pickerTerritoryShow",
          },
        },
        [
          _c("van-picker", {
            attrs: {
              title: "选择省份",
              "show-toolbar": "",
              "default-index": "1",
              columns: _vm.TerritoryColumns,
            },
            on: {
              confirm: _vm.TerritoryOnConfirm,
              cancel: _vm.TerritoryOnCancel,
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          style: { height: "38%" },
          attrs: { position: "bottom", round: "" },
          model: {
            value: _vm.colorArrShow,
            callback: function ($$v) {
              _vm.colorArrShow = $$v
            },
            expression: "colorArrShow",
          },
        },
        [
          _c("van-picker", {
            attrs: {
              title: "选择颜色",
              "show-toolbar": "",
              "default-index": "1",
              columns: _vm.colorArrs,
            },
            on: { confirm: _vm.colorConfirm, cancel: _vm.coloraddCancel },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          style: { height: _vm.cutShow ? "37%" : "43%" },
          attrs: { round: "", position: "bottom" },
          model: {
            value: _vm.keyValue,
            callback: function ($$v) {
              _vm.keyValue = $$v
            },
            expression: "keyValue",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cutShow,
                  expression: "cutShow",
                },
              ],
              staticClass: "key-box",
            },
            [
              _c(
                "div",
                {
                  staticClass: "key-box-title",
                  staticStyle: { "margin-top": "15px" },
                },
                [
                  _c("div", { staticClass: "d1" }, [
                    _c(
                      "span",
                      {
                        staticClass: "d-span",
                        staticStyle: { color: "rgb(92,126,252)" },
                        on: { click: _vm.cutClick },
                      },
                      [_vm._v("中/英")]
                    ),
                  ]),
                  _c("div", { staticClass: "d2" }, [
                    _c("div", [
                      _c("span", { staticClass: "d-span" }, [
                        _vm._v(_vm._s(_vm.plateNumber)),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "d3" }, [
                    _c(
                      "span",
                      {
                        staticClass: "d-span d-span1",
                        staticStyle: { color: "rgb(92,126,252)" },
                        on: { click: _vm.cancelClick },
                      },
                      [_vm._v("取消")]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "key-value",
                  staticStyle: { "margin-top": "13px" },
                },
                _vm._l(_vm.keyVehicleNum1, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "key-num",
                      on: {
                        click: function ($event) {
                          return _vm.keyVehicleNumClick(item)
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(item))])]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "key-value",
                  staticStyle: { "margin-top": "5px" },
                },
                _vm._l(_vm.keyVehicleNum2, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "key-num",
                      on: {
                        click: function ($event) {
                          return _vm.keyVehicleNumClick(item)
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(item))])]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "key-value",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm._l(_vm.keyVehicleNum3, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "key-num",
                        on: {
                          click: function ($event) {
                            return _vm.keyVehicleNumClick(item)
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(item))])]
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "key-num", on: { click: _vm.deleteClick } },
                    [
                      _c("img", {
                        staticClass: "key-num-X",
                        attrs: {
                          src: require("../../assets/image/delete.png"),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "key-value",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm._l(_vm.keyVehicleNum4, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "key-num",
                        on: {
                          click: function ($event) {
                            return _vm.keyVehicleNumClick(item)
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(item))])]
                    )
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "key-num key-btn",
                      staticStyle: { width: "16%" },
                      on: { click: _vm.confirmClick },
                    },
                    [_vm._v(" 确定 ")]
                  ),
                ],
                2
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.cutShow,
                  expression: "!cutShow",
                },
              ],
              staticClass: "key-box",
            },
            [
              _c(
                "div",
                {
                  staticClass: "key-box-title",
                  staticStyle: { "margin-top": "15px" },
                },
                [
                  _c("div", { staticClass: "d1" }, [
                    _c(
                      "span",
                      {
                        staticClass: "d-span",
                        staticStyle: { color: "rgb(92,126,252)" },
                        on: { click: _vm.cutClick },
                      },
                      [_vm._v("中/英")]
                    ),
                  ]),
                  _c("div", { staticClass: "d2" }, [
                    _c("div", [
                      _c("span", { staticClass: "d-span" }, [
                        _vm._v(_vm._s(_vm.plateNumber)),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "d3" }, [
                    _c(
                      "span",
                      {
                        staticClass: "d-span d-span1",
                        staticStyle: { color: "rgb(92,126,252)" },
                        on: { click: _vm.cancelClick },
                      },
                      [_vm._v("取消")]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "key-value",
                  staticStyle: { "margin-top": "13px" },
                },
                _vm._l(_vm.keyVehicle1, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "key-num1",
                      on: {
                        click: function ($event) {
                          return _vm.keyVehicleNumClick(item)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "18px" } }, [
                        _vm._v(_vm._s(item)),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "key-value",
                  staticStyle: { "margin-top": "13px" },
                },
                _vm._l(_vm.keyVehicle2, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "key-num1",
                      on: {
                        click: function ($event) {
                          return _vm.keyVehicleNumClick(item)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "18px" } }, [
                        _vm._v(_vm._s(item)),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "key-value",
                  staticStyle: { "margin-top": "13px" },
                },
                [
                  _vm._l(_vm.keyVehicle3, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "key-num1",
                        on: {
                          click: function ($event) {
                            return _vm.keyVehicleNumClick(item)
                          },
                        },
                      },
                      [
                        _c("span", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v(_vm._s(item)),
                        ]),
                      ]
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "key-num1", on: { click: _vm.deleteClick } },
                    [
                      _c("img", {
                        staticClass: "key-num-X1",
                        attrs: {
                          src: require("../../assets/image/delete.png"),
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "key-value",
                  staticStyle: { "margin-top": "13px" },
                },
                _vm._l(_vm.keyVehicle4, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "key-num1",
                      on: {
                        click: function ($event) {
                          return _vm.keyVehicleNumClick(item)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "18px" } }, [
                        _vm._v(_vm._s(item)),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }